import { EnderecoParmDTO } from "./address";
import { BaseFiltroPagDTO } from "./base-dto";

export class RegistroVisitaParmDTO {
  id: number;
  idInstituicao: number;
  idAgendamento: number;
  presencial: boolean;
  data: string;
  horario: string;
  endereco: EnderecoParmDTO;
  idsVisitantes: number[];
  idsContatos: number[];
  objetivo: string;
  observacao: string;

  horaFimVisita: string;
  objetivoCumprido: boolean;
  visitaAtendida: boolean;
  detalhesVisita: string;
  proximosPassos: string;
  dataPrevProxVisita: string;
}

export class RegistroVisitaFiltroDTO extends BaseFiltroPagDTO {
  idsInstituicoes: number[];
  dataIni: string;
  dataFim: string;
  idsVisitantes: number[];
  idsContatos: number[];
  participacao: string;
  comAgendamento: boolean;
  presencial: boolean;

}